"use strict";

exports.__esModule = true;
exports.createStyled = createStyled;
exports.styled = void 0;

var _styledSystem = require("@manifest-ui/styled-system");

var _shouldForwardProp = require("./shouldForwardProp");

var _themes = require("@manifest-ui/themes");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _isStyleProp = require("./isStyleProp");

var _lodash2 = _interopRequireDefault(require("lodash.omitby"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStyled() {
  return (tag, options) => {
    const {
      label,
      shouldForwardProp = _shouldForwardProp.shouldForwardProp,
      slot: slotOption = 'root',
      themeKey = ''
    } = options ?? {};
    const emotionResolver = (0, _styled.default)(tag, {
      label,
      shouldForwardProp
    });

    const styleResolver = (...args) => {
      const styleArgs = args.map(interpolation => {
        return props => {
          const {
            size: sizeProp,
            sx,
            theme: themeProp,
            variant: variantProp,
            ...other
          } = props;
          const theme = (0, _lodash.default)(themeProp) ? _themes.defaultTheme : themeProp;
          const componentTheme = theme?.components?.[themeKey];
          const slots = componentTheme?.slots;
          const slot = slots?.[slotOption] ?? {};
          const sizes = componentTheme?.sizes;
          const variants = componentTheme?.variants;
          const baseStyles = typeof interpolation === 'function' ? interpolation({ ...props,
            theme
          }) : interpolation;
          const mergedStyles = Object.assign({}, baseStyles, slot);
          const styleProps = (0, _lodash2.default)(other, (_, prop) => !(0, _isStyleProp.isStyleProp)(prop));
          const size = sizeProp ? sizes?.[sizeProp] : {};
          const variant = variantProp ? variants?.[variantProp] : {};
          const composedStyles = Object.assign({}, mergedStyles, size, variant, styleProps, sx);
          return (0, _styledSystem.css)(composedStyles)(theme);
        };
      });
      return emotionResolver(styleArgs);
    };

    return styleResolver;
  };
}

const styled = createStyled();
exports.styled = styled;